'use strict';

var util = require('../util/property-util');
var nocUtil = require('../util/noc-util');

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            enableHours: '='
        },
        template: [
            `
            <div class="form-group row">
                <div class="col-12 pr-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <small>{{'I18N_FILTER.PRESET_LAST' | translate }}</small>
                            </div>
                        </div>
                        <div class="w-25">
                            <input value="1" class="form-control" ng-change="setTimeInput()" ng-model="timeInput" type="number">
                        </div>
                      
                        <select class="form-control" ng-change="setHours()" ng-model="hours">
                            <option ng-show="enableHours" value="1">{{"I18N_FILTER.PRESET_HOUR" | translate}}</option>
                            <option value="24">{{"I18N_FILTER.PRESET_DAY" | translate}}</option>
                            <option value="168">{{"I18N_FILTER.PRESET_WEEK" | translate}}</option>
                            <option value="720">{{"I18N_FILTER.PRESET_MONTH" | translate}}</option>
                            <option value="8760">{{"I18N_FILTER.PRESET_YEAR" | translate}}</option>
                        </select>
                    </div>
                </div>
            </div>
            `
        ].join(''),

        link: function (scope, iElement, iAttrs, ngModel) {
            scope.hours = 24;
            scope.timeInput = 1;
            if (!util.isDefined(scope.ngModel.from) || !util.isDefined(scope.ngModel.to)) {
                persistPeriodToModel(lastHours(scope.timeInput * scope.hours));
            }

            scope.setHours = function () {
                if (util.isDefined(scope.timeInput)) {
                    persistPeriodToModel(lastHours(scope.timeInput * scope.hours));
                }
            };
            scope.setTimeInput = function () {
                if (util.isDefined(scope.hours)) {
                    persistPeriodToModel(lastHours(scope.timeInput * scope.hours));
                }
            };
            function lastHours(hours) {
                if (scope.hours == 1) {
                    return nocUtil.createPeriodHoursAgo(hours);
                } else {
                    var period = nocUtil.createPeriodUpToNow(hours / 24);
                    return {from: period.start, to: period.end};
                }
            }

            function persistPeriodToModel(period) {
                scope.ngModel.from = period.from;
                scope.ngModel.to = period.to;
            }
        }
    };
};